import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_groomer_details, save_groomer_details } from './api';
import type { GroomerDetailsRequest } from './types';

const KEY = ['module-details', 'groomer'] as const;

export function use_save_groomer_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: GroomerDetailsRequest) => save_groomer_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_groomer_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_groomer_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
